module.exports = __webpack_public_path__ + "media/images/flags/bj-9bcaf0680fc030b391ffb81539b8b778.svg";